import React from 'react'
import { StandardLayout } from 'components/StandardLayout'
import { Card } from 'components/basic/Card'

export const NotFoundPage = () => (
  <StandardLayout>
    <Card>404 Error: Route not found</Card>
  </StandardLayout>
)
